import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';
import { Video } from '@/lib/mock-data';

export const useVideoInteractions = () => {
  const [points, setPoints] = useState(1000);
  const [tipAmount, setTipAmount] = useState(50);
  const [showTipAnimation, setShowTipAnimation] = useState(false);
  const { user } = useAuth();
  const { toast } = useToast();

  const handleLike = async (videoData: Video) => {
    if (!user) {
      toast({
        title: "Authentication required",
        description: "Please sign in to like videos",
        variant: "destructive"
      });
      return;
    }

    try {
      const { error } = await supabase
        .from('video_interactions')
        .insert({
          user_id: user.id,
          video_id: videoData.id,
          liked_at: new Date().toISOString()
        });

      if (error) {
        console.error("Error liking video:", error);
        toast({
          title: "Error",
          description: "Failed to like video. Please try again.",
          variant: "destructive"
        });
        return;
      }

      setPoints(prev => prev + 10);
      toast({
        title: "Success",
        description: "Video liked successfully!",
      });
    } catch (error) {
      console.error("Error in handleLike:", error);
      toast({
        title: "Error",
        description: "An unexpected error occurred",
        variant: "destructive"
      });
    }
  };

  const handleTip = (amount: number) => {
    if (!user) {
      toast({
        title: "Authentication required",
        description: "Please sign in to tip",
        variant: "destructive"
      });
      return;
    }

    if (points >= amount) {
      setPoints(prev => prev - amount);
      setShowTipAnimation(true);
      setTimeout(() => setShowTipAnimation(false), 1000);
    }
  };

  return {
    points,
    tipAmount,
    setTipAmount,
    showTipAnimation,
    handleLike,
    handleTip
  };
};